<div class="display-layout-column layout-gap-15">
  <div class="headline">ERateSheet</div>
  <mat-divider class="headlineDivider"></mat-divider>

  <div class="display-layout-column justify-content-center layout-align-start">
    <div class="display-layout-row layout-gap-10 layout-align-center-center"
      [formGroup]="searchForm"
      >
      <mat-form-field appearance="fill">
        <mat-label>Search</mat-label>
        <input formControlName="filter" matInput (keyup)="applyFilter()" />

        <mat-icon matPrefix>search </mat-icon>

        @if (searchForm.value.filter != '') {
          <button
            matSuffix
            mat-icon-button
            (click)="clearSearch()"
            >
            <mat-icon matSuffix> clear </mat-icon>
          </button>
        }
      </mat-form-field>

      <div class="display-layout-row layout-align-center-center">
        <button class="searchButton" mat-stroked-button>search</button>
      </div>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="destination_airport_code">
      <th mat-header-cell *matHeaderCellDef>destination airport</th>
      <td mat-cell *matCellDef="let element">
        {{ element.destination_airport_code }}
      </td>
    </ng-container>

    <ng-container matColumnDef="destination_country_iso_code">
      <th mat-header-cell *matHeaderCellDef>destination country iso</th>
      <td mat-cell *matCellDef="let element">
        {{ element.destination_country_iso_code }}
      </td>
    </ng-container>

    <ng-container matColumnDef="carrier_prefix">
      <th mat-header-cell *matHeaderCellDef>carrier prefix</th>
      <td mat-cell *matCellDef="let element">{{ element.carrier_prefix }}</td>
    </ng-container>

    <ng-container matColumnDef="gsa_name">
      <th mat-header-cell *matHeaderCellDef>gsa</th>
      <td mat-cell *matCellDef="let element">{{ element.gsa_name }}</td>
    </ng-container>

    <ng-container matColumnDef="product_name">
      <th mat-header-cell *matHeaderCellDef>product name</th>
      <td mat-cell *matCellDef="let element">{{ element.product_name }}</td>
    </ng-container>

    <ng-container matColumnDef="minimum_rate">
      <th mat-header-cell *matHeaderCellDef>minimum rate</th>
      <td mat-cell *matCellDef="let element">{{ element.minimum_rate }}</td>
    </ng-container>

    <ng-container matColumnDef="normal_flat_rate">
      <th mat-header-cell *matHeaderCellDef>normal flat rate</th>
      <td mat-cell *matCellDef="let element">
        {{ element.normal_flat_rate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="45_kg">
      <th mat-header-cell *matHeaderCellDef>45kg</th>
      <td mat-cell *matCellDef="let element">{{ element.a45_kg }}</td>
    </ng-container>

    <ng-container matColumnDef="100_kg">
      <th mat-header-cell *matHeaderCellDef>100kg</th>
      <td mat-cell *matCellDef="let element">{{ element.a100_kg }}</td>
    </ng-container>

    <ng-container matColumnDef="150_kg">
      <th mat-header-cell *matHeaderCellDef>250kg</th>
      <td mat-cell *matCellDef="let element">{{ element.a250_kg }}</td>
    </ng-container>

    <ng-container matColumnDef="300_kg">
      <th mat-header-cell *matHeaderCellDef>300kg</th>
      <td mat-cell *matCellDef="let element">{{ element.a300_kg }}</td>
    </ng-container>

    <ng-container matColumnDef="500_kg">
      <th mat-header-cell *matHeaderCellDef>500kg</th>
      <td mat-cell *matCellDef="let element">{{ element.a500_kg }}</td>
    </ng-container>

    <ng-container matColumnDef="1000_kg">
      <th mat-header-cell *matHeaderCellDef>1000kg</th>
      <td mat-cell *matCellDef="let element">{{ element.a1000_kg }}</td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef>Notes</th>
      <td mat-cell *matCellDef="let element">{{ element.notes }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    class="display-flex"
    #paginator
    [pageSizeOptions]="[20, 50, 100, 200, 500]"
    >
  </mat-paginator>
</div>
